import { render } from "./ProductDetailedInfo.vue?vue&type=template&id=1b98fbe5&scoped=true"
import script from "./ProductDetailedInfo.vue?vue&type=script&lang=js"
export * from "./ProductDetailedInfo.vue?vue&type=script&lang=js"

import "./ProductDetailedInfo.vue?vue&type=style&index=0&id=1b98fbe5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b98fbe5"]])

export default __exports__